// Static fallback used only if backend not reachable; backend is the source of truth.
// Each `key` is the value stored on `product.category` in MongoDB.
// `parent` defines a hierarchy: filtering by parent includes all children.
export const CATEGORIES = [
  { key: "All", label: "Tutti" },
  { key: "Action Figure", label: "Action Figure" },
  { key: "Figure", label: "Figure" },
  { key: "Toys", label: "Toys" },
  { key: "Model Kit", label: "Model Kit" },
  { key: "Gadget", label: "Gadget" },
  { key: "Poster", label: "Poster", parent: "Gadget" },
  { key: "Peluche", label: "Peluche", parent: "Gadget" },
  { key: "Die-cast", label: "Die-cast" },
  { key: "Limited Editions", label: "Edizioni Limitate" },
  { key: "Merchandise", label: "Merchandise" },
];

/** Returns the set of category keys that should match when filtering by `key`
 * (includes itself and all descendant categories). */
export function expandCategory(key) {
  if (!key || key === "All") return null; // no filter
  const direct = new Set([key]);
  for (const c of CATEGORIES) {
    if (c.parent === key) direct.add(c.key);
  }
  return direct;
}
